<template>
  <div class="share-panel" :data-block-interaction="openAlpha === 1 && !$root.platform.mobile ? '' : 'nope'" @touchmove.prevent="preventEvent">
    <div class="centered-stuff">
      <h1>Share your hopes</h1>
      <div class="icons">
        <FacebookIcon @click.native="onSocialClick('facebook')" class="icon" data-block-interaction />
        <TwitterIcon @click.native="onSocialClick('twitter')" class="icon" data-block-interaction />
      </div>
      <p>
        <a data-block-interaction :href="imageUrl" target="_blank" download="google-hope.jpg">Download an image</a> of your Hopes<br>or <a data-block-interaction @click="copyShareableLink">get a shareable link</a>
      </p>

      <el-button class="button" @click="$emit('update:openAlpha', 0)">BACK</el-button>

      <transition appear>
        <div v-if="copiedLink" class="copied-link-message">
          <span>Copied to your clipboard</span>
        </div>        
      </transition>
    </div>
  </div>
</template>

<script>
import FacebookIcon from '@/assets/img/facebook_icon.svg'
import TwitterIcon from '@/assets/img/twitter_icon.svg'
import ElButton from 'element-ui/packages/button'
import Platform from '@/platform'

export default {
  name: 'SharePanel',
  components: {
    FacebookIcon,
    TwitterIcon,
    ElButton
  },
  props: {
    openAlpha: {
      required: true,
      type: Number
    },

    totemData: {
      required: false,
      type: Object
    }
  },
  data: function () {
    return {
      copiedLink: false
    }
  },

  mounted: function () {

  },

  beforeDestroy: function () {

  },

  computed: {
    imageUrl () {
      return 'https://accurat-ghope.appspot.com/thumbnail/' + this.totemData.key
    }
  },

  methods: {
    preventEvent: function () {},

    copyShareableLink () {
      const el = document.createElement('textarea')
      el.style.position = 'absolute'
      el.value = 'https://accurat-ghope.appspot.com/social/' + this.totemData.key
      el.style.opacity = '0'

      el.addEventListener('click', () => {
        console.log(':D')
      })

      document.body.appendChild(el)
      el.focus()

      if (Platform.ios) {
        let range = document.createRange()
        range.selectNodeContents(el)

        let selection = window.getSelection()
        selection.removeAllRanges()
        selection.addRange(range)
        el.setSelectionRange(0, 999999)
      } else {
        el.select()
      }

      document.execCommand('copy')

      setTimeout(() => {
        document.body.removeChild(el)
        this.copiedLink = true
      }, 100)
    },

    share (url, width = 557, height = 400) {
      let opts = 'width=' + width + ', height=' + height + ', scrollbars=0, ' +
                'top=' + ((window.innerHeight / 2) - (height / 2)) + ', ' +
                'left=' + ((window.innerWidth / 2) - (width / 2))

      window.open(url, '_blank', opts)
    },

    onSocialClick (social) {
      let key = this.totemData.key

      if (social === 'twitter') {
        let url = 'https://accurat-ghope.appspot.com/social/' + key

        let path = 'https://twitter.com/intent/tweet?url=' + url

        this.share(path)
      }

      if (social === 'facebook') {
        let url = 'https://accurat-ghope.appspot.com/social/' + key
        let path = 'https://www.facebook.com/sharer/sharer.php?u=' + encodeURI(url)

        this.share(path)
      }
    }
  },

  watch: {

  }
}
</script>

<style scoped lang="scss">
@import 'variables';
@import 'mixins';

.share-panel {
  position: absolute;
  z-index: $z-ui;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  user-select: none;
  pointer-events: none;
  // background-color: color-alpha($c-black, 0.5);
}

a {
  color: $c-gray;
  cursor: pointer;
  text-decoration: none;
  pointer-events: all;
  position: relative;

  &::after {
    content: ' ';
    display: block;

    position: absolute;

    bottom: -4px;
    left: 0;
    right: 0;

    margin: 0 auto;

    width: 98%;
    height: 1px;

    background-color: $c-gray;
    opacity: 0.7;

    transition: opacity 0.4s $ease-in-out-quad;

    backface-visibility: hidden;
  }

  &:hover {
    &::after {
      opacity: 0.5;
    }
  }
}

.icon-shadow {
  width: 84px;
  height: 84px;
  padding: 60px 10px;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  margin: auto;
  z-index: -1;
  opacity: 0.2;

  &.facebook-shadow {
    transform: translate(-48px, 18px);
  }

  &.twitter-shadow {
    transform: translate(48px, 18px);
  }
}

.back-button {
  margin: 40px auto 0;
  display: table;
  width: 50px;
  border: 1px solid #333;
  color: #333;
  text-align: center;
  border-radius: 5px;
  width: 100px;
  height: 39px;
  line-height: 39px;
  cursor: pointer;
  pointer-events: all;
  backface-visibility: hidden;

  transition: color 0.4s $ease-in-out-quad, background 0.4s $ease-in-out-quad;

  &:hover {
    color: $c-white;
    background: #333;
  }
}

.button {
  margin: 40px auto 0;
  cursor: pointer;
  pointer-events: all;  
}

.close-button {
  font-size: 40px;
  font-weight: 100;
  position: absolute;
  left: 50px;
  top: 100px;
  cursor: pointer;
  display: none;
  color: $c-gray;
  @include breakpoint(#{$bp-sm}px) {
    display: block;
  }
}

.centered-stuff {
  color: $c-gray;
  text-align: center;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  letter-spacing: 1px;
  width: 100%;
  pointer-events: none;
}

h1 {
  font-size: 24px;
  text-transform: uppercase;
  font-weight: 600;
}

p {
  line-height: 34px;
}

.icon {
  pointer-events: all;
  width: 60px;
  height: 60px;
  padding: 40px 10px;
  display: inline-block;
  cursor: pointer;
  @include breakpoint(#{$bp-sm}px) {
    width: 70px;
    height: 70px;
    padding: 60px 10px;
  }
}

.copied-link-message {
  text-align: center;
  position: absolute;

  margin: 30px auto 0;
  display: block;

  right: 0;
  left: 0;
}

</style>



// WEBPACK FOOTER //
// src/organisms/SharePanel.vue